import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  NavigationEnd,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import {combineLatest, Observable} from 'rxjs';
import * as fromStore from "../../store";
import {Store} from '@ngrx/store';
import {filter, first, switchMap} from 'rxjs/operators';
import {UserSubscriptionCategory} from "../../user/user-subscription";
import {UserSubscriptionStatus} from "../../user/user-subscription-status";

@Injectable()
export class SubscriptionUpgradeAvailableGuard implements CanActivate {
  private userRoleId: number;
  private upgradedAccount: boolean;
  private subscriptionPlanPage: boolean;

  constructor(
    private _router: Router,
    private _store: Store<fromStore.DbStoreState>,
  ) {
    this._store.select(fromStore.getCurrentWorkspace)
      .subscribe(currentWorkspace => {
        this.userRoleId = currentWorkspace && currentWorkspace.roleId;
      });

    this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
      )
      .subscribe(event => {
        this.upgradedAccount = window.location.href.indexOf("upgraded_account") > -1;
        this.subscriptionPlanPage = window.location.href.indexOf("subscription-plan") > -1;
      });
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise<boolean>((resolve: Function, reject: Function): void => {
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          first(loaded => loaded),
          switchMap(() => combineLatest(
            this._store.select(fromStore.getUser),
            this._store.select(fromStore.getUserSubscription),
            this._store.select(fromStore.getUserUpgradableSubscription()),
            this._store.select(fromStore.getUserAvailableHostingSubscriptions()),
          )),
          first()
        )
        .subscribe(([user, userSubscription, userUpgradableSubscription, availableHostingSubscriptions]) => {
          const hasUpgrade = (availableHostingSubscriptions.length > 0);
          if (!hasUpgrade) {
            resolve(false);
            this._router.navigate(['/websites']);
          }
          if (!userUpgradableSubscription && userSubscription && !this.subscriptionPlanPage && !this.upgradedAccount && userSubscription.category === UserSubscriptionCategory.ENTERPRISE) {
            resolve(false);
            this._router.navigate(['/websites']);
          }
          if (!userSubscription?.apiResellerFree && userSubscription.platformPaidClient && [UserSubscriptionStatus?.canceled, UserSubscriptionStatus.expired].includes(userSubscription?.status)) {
            resolve(false);
            this._router.navigate(['/workspace/subscription-plan']);
          }
          resolve(true);
        });
    });
  }

}
